var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDobExclude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.71094,
    y: 3.65625,
    width: 16.5856,
    height: 16.5856,
    rx: 2.11724,
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 15.9502C11.9726 15.9502 11.9502 15.9726 11.9502 16.0002C11.9502 16.0278 11.9726 16.0502 12.0002 16.0502C12.0278 16.0502 12.0502 16.0278 12.0502 16.0002C12.0502 15.9726 12.0278 15.9502 12.0002 15.9502",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 13.5023V12.0017C13.1059 12.0017 14.0017 11.1059 14.0017 10.0008C14.0017 8.8958 13.1059 8 12.0008 8C10.8958 8 10 8.8958 10 10.0008",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43808 2V3.65856V2Z",
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43808 2V3.65856",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5553 2V3.65856V2Z",
    fill: "#3158F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5553 2V3.65856",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobExclude);
export default __webpack_public_path__ + "static/media/dob-exclude.d3c10e14874acf95243b6a9469baee5d.svg";
export { ForwardRef as ReactComponent };